import { PAGE_TYPE_CART, TENANT_BE } from 'shared/consts'
import {
  CART_CTA_CLICK,
  CHANGE_CTA_TEXT_NAME_BE,
} from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'
import { getExperimentNamePerTenant } from 'shared/experiments/utils/tenantBasedExperimentsUtils'
import trackOptimizelyEvent from 'shared/experiments/utils/trackOptimizelyEvent'
import store from 'shared/store'

export default () => {
  const {
    publicConfig: { tenant, deviceClass },
    pageProperties: { pageType },
  } = store.getState().publicRuntimeConfig
  const changeCtaTextExperiment = getExperimentNamePerTenant(
    CHANGE_CTA_TEXT_NAME_BE,
    tenant,
    deviceClass
  )

  const { isEnabled } = getExperimentOnClient(changeCtaTextExperiment)

  const ctaContainers = [
    document.querySelector('.o-Cart__button-container'),
    document.querySelector('.o-CartSumBox__CheckoutButton-container'),
  ]
  if (
    !isEnabled ||
    ctaContainers?.length === 0 ||
    tenant !== TENANT_BE ||
    pageType !== PAGE_TYPE_CART
  ) {
    return
  }

  void activateExperiment(changeCtaTextExperiment)

  ctaContainers.forEach(ctaContainer => {
    ctaContainer?.addEventListener('click', () => {
      trackOptimizelyEvent(CART_CTA_CLICK)
    })
  })
}
